import React from "react";
import { Tabel } from "../core";
import { media } from "../styles";
import styled from "styled-components";
const CHANGE_DATE_FORMAT = require("../helper/utils/datFormat");
const StyledTabel = styled(Tabel)`
  .ant-table-thead > tr > th {
    background: none;
    font-weight: 500;
    font-size: 18px;
    line-height: 27px;
    border-bottom: 2px solid #e7ecf4;

    color: #404e67;
  }
  .ant-table-tbody > tr > td {
    font-size: 16px;
    line-height: 20px;
    color: #404e67;
    border-bottom: 2px solid #e7ecf4;
  }
  .ant-table-tbody > tr:last-child td {
    border-bottom: none;
  }
  .ant-table-container {
    ${media.minidesktop`overflow-x: scroll;`};
  }
`;
const dataSource = [
  {
    key: "1",
    date: "23-3-2020",
    status: "Drafts",
    desc: "Bill Added",
  },
  {
    key: "2",
    date: "23-3-2020",
    status: "Drafts",
    desc: "Bill Added",
  },
  {
    key: "3",
    date: "23-3-2020",
    status: "Drafts",
    desc: "Bill Added",
  },
];

const columns = [
  {
    title: "Date",
    dataIndex: "date",
    key: "date",
    render: (text, record, index) => {
      return <span>{CHANGE_DATE_FORMAT.changeDateFormat(record.date)}</span>;
    },
    width: 150,
  },
  {
    title: "Status",
    dataIndex: "status",
    key: "status",
    width: 150,
  },
  {
    title: "Description",
    dataIndex: "desc",
    key: "desc",
    width: 150,
  },
];
const InvoiceHistory = () => {
  return (
    <StyledTabel dataSource={dataSource} pagination={false} columns={columns} />
  );
};

export default InvoiceHistory;
